import { RequirementStatus } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsAllRequirementsComplete = (
  requirements: { status?: RequirementStatus }[]
): boolean => {
  if (requirements.length === 0) {
    return true;
  }

  return requirements.every(e => e.status === RequirementStatus.COMPLETED);
};
